import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, canonical, jsonLd, image }) {
  useEffect(() => {
    const img = image || "https://cartocash.com.au/og-default.jpg";
    // Canonical must never carry tracking params (utm_*, gclid, fbclid).
    let cleanCanonical = canonical;
    try {
      const base = canonical || (window.location.origin + window.location.pathname);
      const u = new URL(base);
      ["gclid", "fbclid"].forEach((p) => u.searchParams.delete(p));
      [...u.searchParams.keys()].filter((k) => k.toLowerCase().startsWith("utm_")).forEach((k) => u.searchParams.delete(k));
      cleanCanonical = u.origin + u.pathname + (u.search || "");
    } catch (e) { console.debug("canonical parse failed, using provided value", e?.message); }
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "en_AU");
    setMeta("property", "og:image", img);
    if (cleanCanonical) setMeta("property", "og:url", cleanCanonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (cleanCanonical) {
      if (!link) { link = document.createElement("link"); link.setAttribute("rel", "canonical"); document.head.appendChild(link); }
      link.setAttribute("href", cleanCanonical);
    }

    let script = document.getElementById("ld-json-page");
    if (script) script.remove();
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "ld-json-page";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, canonical, jsonLd, image]);
  return null;
}
